export const fieldMappings = {
    dateDue: 'main.general.date_due',
    dateIssued: 'main.general.date_issued',
    invoiceNumber: 'main.general.invoice_number',
};
